const MAX_RETRIES = 2;
const RETRIABLE_4XX_STATUSES: ReadonlySet<number> = new Set([408, 429]);

interface ErrorWithResponseStatus {
    response?: { status?: number };
}

// 4xx (other than 408/429) means the request is permanently invalid - retrying
// only triples failed calls and Sentry noise. No response (network drop) and
// 5xx are transient, so those still get MAX_RETRIES attempts.
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
    if (failureCount >= MAX_RETRIES) return false;
    const status = (error as ErrorWithResponseStatus)?.response?.status;
    if (status === undefined) return true;
    if (status < 400 || status >= 500) return true;
    return RETRIABLE_4XX_STATUSES.has(status);
}
